__turbopack_context__.v({
  "calloutSection": "kCxRDG_calloutSection",
  "capTopSection": "kCxRDG_capTopSection",
  "capabilitiesCards": "kCxRDG_capabilitiesCards",
  "contactModal": "kCxRDG_contactModal",
  "footer": "kCxRDG_footer",
  "header": "kCxRDG_header",
  "root": "kCxRDG_root",
  "serviceMessage": "kCxRDG_serviceMessage",
  "serviceMessageWrapper": "kCxRDG_serviceMessageWrapper",
});
